import React from 'react'
import PropTypes from 'prop-types'

import Text from 'components/_new/typography/Text/Text'

import messages from './messages'


const EmptyText = ({ className }) => <Text className={className} message={messages.text} />

EmptyText.propTypes = {
  className: PropTypes.string,
}


export default EmptyText
